import { useQuery } from "@tanstack/react-query";
import { Hero } from "@/components/Hero";
import { BlogsSection } from "@/components/BlogsSection";
import { SEO } from "@/components/SEO";
import { fetchBlogs } from "@/lib/api";

export default function Landing({ onProveIt }) {
  const { data: blogs = [], isLoading } = useQuery({ queryKey: ["blogs"], queryFn: fetchBlogs });
  const origin = window.location.origin;
  return (
    <>
      <SEO
        title="TruCitizen™ | Are you a TruCitizen?"
        description="TruCitizen™ is a social platform that celebrates India. Prove your knowledge of India through timed challenges, earn badges and rankings, and connect with fellow citizens. By CreJik Technologies."
        path="/"
        keywords="TruCitizen, TruCitizen app, India quiz challenge, Indian citizenship challenge, CreJik Technologies"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "TruCitizen",
          url: origin,
          publisher: { "@type": "Organization", name: "CreJik Technologies Private Limited" },
        }}
      />
      <Hero onProveIt={onProveIt} />
      <BlogsSection blogs={blogs} loading={isLoading} />
    </>
  );
}
